import { render } from "./appRaceInfo.vue?vue&type=template&id=00145612&scoped=true"
import script from "./appRaceInfo.vue?vue&type=script&lang=js"
export * from "./appRaceInfo.vue?vue&type=script&lang=js"

import "./appRaceInfo.vue?vue&type=style&index=0&id=00145612&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00145612"]])

export default __exports__